import { render } from "./ExerciseGrid.vue?vue&type=template&id=0a9524e6&scoped=true&ts=true"
import script from "./ExerciseGrid.vue?vue&type=script&lang=ts"
export * from "./ExerciseGrid.vue?vue&type=script&lang=ts"

import "./ExerciseGrid.vue?vue&type=style&index=0&id=0a9524e6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a9524e6"]])

export default __exports__